import { ApiResponse } from "../../types/common";
import { EmployeeRoles } from "../../types/RoleType";
import { RoleResponse, CreateRoleDto, PermissionResponse, UpdateRolePermissionsDto, PermissionRegistry } from "../../types/userManagement";
import { axiosInstance } from "./axios";

export const roleService = {
    getEmployeeRoles: async (): Promise<EmployeeRoles[]> => {
        const response = await axiosInstance.get<ApiResponse<EmployeeRoles[]>>("v1/Roles/Employee");
        if (!response.data.succeeded) {
            throw new Error(response.data.messages?.[0] || "Failed to get employee roles");
        }
        return response.data.data;
    },

    getAllRoles: async (): Promise<RoleResponse[]> => {
        const response = await axiosInstance.get<ApiResponse<RoleResponse[]>>("v1/Roles");
        if (!response.data.succeeded) {
            throw new Error(response.data.messages?.[0] || "Failed to get roles");
        }
        return response.data.data;
    },

    getRoleById: async (id: string): Promise<RoleResponse> => {
        const response = await axiosInstance.get<ApiResponse<RoleResponse>>(`v1/Roles/${id}`);
        if (!response.data.succeeded) {
            throw new Error(response.data.messages?.[0] || "Failed to get role");
        }
        return response.data.data;
    },

    createRole: async (dto: CreateRoleDto): Promise<string> => {
        const response = await axiosInstance.post<ApiResponse<string>>("v1/Roles", dto);
        if (!response.data.succeeded) {
            throw new Error(response.data.messages?.[0] || "Failed to create role");
        }
        return response.data.data;
    },

    updateRole: async (id: string, dto: CreateRoleDto): Promise<string> => {
        const response = await axiosInstance.put<ApiResponse<string>>(`v1/Roles/${id}`, dto);
        if (!response.data.succeeded) {
            throw new Error(response.data.messages?.[0] || "Failed to update role");
        }
        return response.data.data;
    },

    deleteRole: async (id: string): Promise<void> => {
        const response = await axiosInstance.delete<ApiResponse<void>>(`v1/Roles/${id}`);
        if (!response.data.succeeded) {
            throw new Error(response.data.messages?.[0] || "Failed to delete role");
        }
    },

    getRolePermissions: async (id: string): Promise<PermissionResponse> => {
        const response = await axiosInstance.get<ApiResponse<PermissionResponse>>(`v1/Roles/${id}/permissions`);
        if (!response.data.succeeded) {
            throw new Error(response.data.messages?.[0] || "Failed to get role permissions");
        }
        return response.data.data;
    },

    updateRolePermissions: async (dto: UpdateRolePermissionsDto): Promise<void> => {
        const response = await axiosInstance.put<ApiResponse<void>>(`v1/Roles/${dto.roleId}/permissions`, dto);
        if (!response.data.succeeded) {
            throw new Error(response.data.messages?.[0] || "Failed to update role permissions");
        }
    },

    getPermissionRegistry: async (): Promise<PermissionRegistry> => {
        const response = await axiosInstance.get<ApiResponse<PermissionRegistry>>("v1/Roles/registry");
        if (!response.data.succeeded) {
            throw new Error(response.data.messages?.[0] || "Failed to get permission registry");
        }
        return response.data.data;
    },
};